import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  FieldValue,
} from "@atgof-firebase/firebase";
import React from "react";
import { RootStackParamList } from "../types";
import MembershipDetailPage from "../components/pages/MembershipDetailPage";
import { UserContext } from "../data/userContext";
import { useProject } from "../data/useProject";
import { useNavigation } from "@react-navigation/native";
import { ProgressBar } from "react-native-paper";
import {
  Colour,
  MembershipRoles,
  normaliseColour,
} from "../common/model/project/membership";

export default function MembershipScreen({
  route,
}: NativeStackScreenProps<RootStackParamList, "membership">) {
  const { itemId } = route.params;
  const isInvitation = route.params.isInvitation === "true";
  const { goBack } = useNavigation();
  const project = useProject();
  const userContext = React.useContext(UserContext);
  const itemRef = React.useMemo<DocumentReference | undefined>(
    () =>
      project
        ?.collection(isInvitation ? "invitations" : "memberships")
        .doc(itemId),
    [project, isInvitation, itemId],
  );
  const readOnly = !isInvitation && itemRef?.id === userContext.user.id;
  const [item, setItem] = React.useState(
    undefined as DocumentSnapshot<DocumentData> | undefined,
  );
  React.useEffect(() => itemRef?.onSnapshot(setItem), [itemRef]);
  function updateRoles(newRoles: MembershipRoles) {
    if (itemRef && item)
      itemRef.update({ roles: newRoles, lastModifiedBy: userContext.user.ref });
  }
  if (!item) return <ProgressBar indeterminate style={{ width: 800 }} />;
  const inkColour: Colour | undefined = item.get("inkColour");
  return (
    <MembershipDetailPage
      readOnly={readOnly}
      isLoading={item === undefined}
      isInvitation={isInvitation}
      userName={item.get("displayName")}
      email={item.get("email")}
      inkColour={inkColour ? normaliseColour(inkColour) : undefined}
      onInkColourChanged={(inkColour) => item.ref.update({ inkColour })}
      notificationPrefs={item.get("notifications")}
      onNotificationPrefsChanged={(notifications) =>
        item.ref.update({ notifications })
      }
      roles={item.get("roles")}
      onRolesChanged={readOnly ? undefined : updateRoles}
      deleteAction={
        readOnly
          ? undefined
          : isInvitation
            ? () => ({
                promise: itemRef?.delete(),
                undo: undefined,
              })
            : itemRef
      }
    />
  );
}
